import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zhk3ege2r2: FaireBrandEntity = {
  token: "b_zhk3ege2r2",
  type: "brand",
  name: "SM WARDROBE",
  avatarUrl:
    "https://cdn.faire.com/fastly/485d3cff2802d049346ca39a15e4610c17fe3ffdfc639d54bd1433014b227624.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/805a83b75a82f85cde50d1106e679d827a6d95d582a187c0b72db54b3099a056.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/485d3cff2802d049346ca39a15e4610c17fe3ffdfc639d54bd1433014b227624.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/805a83b75a82f85cde50d1106e679d827a6d95d582a187c0b72db54b3099a056.jpeg",
  location: "RICHMOND HILL, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 146,
  isTopShop: true,
  isInsider: true,
  description:
    "Established in 2012, SM Wardrobe aims to deliver an exquisite clothing collection, with unique prints and great fabrics. SM-Wardrobe is a fast-growing women’s fashion apparel company, based in New York City. Carrying New York City’s hot trends, our goal is to provide all women affordable wardrobe with diverse selections.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:51.589Z",
    importedBy: "entity-db-cli",
  },
};
